import { AuthApi } from "api/auth";
import { ResponseCode } from "contants/response";
import { handleResetData } from "helpers/handleResetData";
import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { selectToken, selectUsername, updateIsAuthenticated } from "store/auth";
import { setOpenModal } from "store/modal";

import { useAppDispatch, useAppSelector } from "./app-hook";

export const useVerify = () => {
  const navigate = useNavigate();

  const dispatch = useAppDispatch();

  const username =
    useAppSelector(selectUsername) || localStorage.getItem("username");
  const token = useAppSelector(selectToken) || localStorage.getItem("token");

  const [isLoading, setIsLoading] = useState<boolean>(true);

  const fetchVerifyToken = useCallback(async () => {
    if (!username || !token) {
      setTimeout(() => {
        navigate("/");
        dispatch(setOpenModal("signin"));
      }, 500);
      return;
    }
    const response = await AuthApi.verifyToken(username, { username, token });
    setTimeout(() => {
      setIsLoading(false);
    }, 500);
    if (response.status === ResponseCode.SUCCESS) {
      dispatch(updateIsAuthenticated(true));
      return;
    }

    handleResetData(dispatch, navigate);
  }, [username]);

  useEffect(() => {
    fetchVerifyToken();
  }, [fetchVerifyToken]);

  return { isLoading };
};
